import React from 'react';
import { Button } from 'react-bootstrap';

import ItemInfos from 'components/layout/item/ItemInfos';

export default class LeadHeaderItems extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showAll: false,
    };
  }

  render() {
    const { items, entityLoaded, inModal, shippingOutput } = this.props;
    const { showAll } = this.state;

    let showItems = [];
    if (entityLoaded) {
      if (showAll) {
        showItems = items;
      } else {
        for (let i = 0; i < 2 && i < items.length; i++) {
          showItems.push(items[i]);
        }
      }

      return (
        <div>
          {showItems.map(item => {
            return (
              <div key={item.id}>
                <ItemInfos entity={item.item} entityVariant={item.variant} withLink addEditAction inModal={inModal} shippingOutput={shippingOutput}/>
              </div>
            );
          })}

          {!showAll && items.length > 2 && (
            <div class="text-center m-t-15">
              <Button class="btn-rounded" onClick={() => this.setState({ showAll: true })}>
                <i class="fa fa-angle-down" />
              </Button>
            </div>
          )}
        </div>
      );
    }

    return null;
  }
}
LeadHeaderItems.defaultProps = {
  inModal: false,
};
